import type { CanalResumo, ResumoBot } from '@/services/api/analytics-bot';
import { n, pct, usd, usd4 } from '../format';
import Avisos from './Avisos';
import EstadoBloco from './EstadoBloco';

interface DadosTotaisProps {
    resumo: ResumoBot | undefined;
    rotulo: string;
    recorte: string;
    carregando: boolean;
    atualizando: boolean;
    erro: boolean;
    onTentar: () => void;
}

const LINHAS: { l: string; v: (c: CanalResumo) => string; rev?: boolean }[] = [
    { l: 'Mensagens enviadas', v: c => n(c.enviadas) },
    { l: 'Mensagens entregues', v: c => n(c.entregues) },
    { l: 'Taxa de entrega', v: c => pct(c.taxa_entrega_pct, 1) },
    { l: 'Cliques', v: c => n(c.cliques) },
    { l: 'Clicadores únicos', v: c => n(c.clicadores_unicos) },
    { l: 'CTR sobre entregues', v: c => pct(c.ctr_pct) },
    { l: 'Receita', v: c => usd(c.receita), rev: true },
    { l: 'RPC · receita por clique', v: c => usd4(c.rpc) },
];

/** Flow e broadcast lado a lado, nas mesmas métricas e denominadores. */
export default function DadosTotais({ resumo, rotulo, recorte, carregando, atualizando, erro, onTentar }: DadosTotaisProps) {
    return (
        <div className="card">
            <div className="card-h">
                <div>
                    <div className="card-t">Dados totais · flow contra broadcast</div>
                    <div className="card-s">Período: {rotulo}{recorte}</div>
                </div>
            </div>
            {!resumo ? (
                <EstadoBloco carregando={carregando} erro={erro} onTentar={onTentar} />
            ) : (
                <div className="vs" data-loading={atualizando ? 1 : 0}>
                    <div className="vh" />
                    <div className="vh flow"><b style={{ color: 'var(--teal)' }}>Flow</b><span>automação da página</span></div>
                    <div className="vh broad"><b style={{ color: 'var(--green)' }}>Broadcast</b><span>disparo em massa</span></div>
                    {LINHAS.map(x => [
                        <div key={`${x.l}-l`}>{x.l}</div>,
                        <div key={`${x.l}-f`} className={`flow num${x.rev ? ' rev' : ''}`}>{x.v(resumo.canais.flow)}</div>,
                        <div key={`${x.l}-b`} className={`broad num${x.rev ? ' rev' : ''}`}>{x.v(resumo.canais.broadcast)}</div>,
                    ])}
                </div>
            )}
            <Avisos avisos={resumo?.avisos} />
        </div>
    );
}
